export const RANGE_DAILY = 'rangeDaily';
export const RANGE_WEEKLY = 'rangeWeekly';
export const RANGE_MONTHLY = 'rangeMonthly';

export const RANGE_TIME = "rangeTime";

export const RANGE_DATE = 'rangeDate';

export const RANGE_DAY_MONTH = 'rangeDayMonth';

export const SINGLE_DAILY = 'singleDaily';
export const CONTRAST_DAILY = 'contrastDaily';
export const CONTRAST_DAILY2 = 'contrastDaily2';
export const STATISTIC_DAILY = 'statisticDate';
export const CONTRAST_DAITE = 'contrastDate';

export const DATE_RANGE_ARR = [RANGE_DAILY,RANGE_WEEKLY,RANGE_TIME,RANGE_MONTHLY,RANGE_DATE];

export const DATE_FILTER_ARR = [RANGE_DAILY,RANGE_WEEKLY,RANGE_TIME,RANGE_MONTHLY,RANGE_DATE,RANGE_DAY_MONTH,SINGLE_DAILY,STATISTIC_DAILY,CONTRAST_DAILY,CONTRAST_DAITE,CONTRAST_DAILY2];

export const DATE_FILTER_ARR_NO_REBASE = [ RANGE_DAY_MONTH ];

export const DATE_RANGE_DAILY_WEEK_MONTH_ARR = [RANGE_DAILY,RANGE_WEEKLY,RANGE_MONTHLY];

export const DATE_SINGLE_ARR:string [] = [SINGLE_DAILY,CONTRAST_DAILY,CONTRAST_DAILY2];

export const DATE_TIME_RANGE = [RANGE_TIME,RANGE_DATE,STATISTIC_DAILY,CONTRAST_DAITE];
export const DATE_TIME_RANGE_EXCLUDE_CONTRAST = [RANGE_TIME,RANGE_DATE,STATISTIC_DAILY];

export const DATE_SINGLE_TYPE_DAILY_ARR = [RANGE_DAILY,SINGLE_DAILY,CONTRAST_DAILY,CONTRAST_DAILY2];

export const TIMETYPE_OBJ:{[key:string]:string;} = {
  [RANGE_DAILY]: 'date',
  [RANGE_WEEKLY]: 'week',
  [RANGE_MONTHLY]: 'month',
};

export const TIMETYPE_DURATION_VALUE_TYPE = {
  [RANGE_DAILY]: 'today',
  [RANGE_WEEKLY]: 'thisWeek',
  [RANGE_MONTHLY]: 'thisMonth',
  [SINGLE_DAILY]: 'today',
  [CONTRAST_DAILY]: 'today',
  [CONTRAST_DAILY2]: 'today',
};

export const ZONE = 'zone';
export const REGION = 'region';
export const SYSTEM = 'system';
export const CHANNEL = 'channel';
export const LANGUAGE = 'lang';
export const BUNDLE = 'bundle';
export const NETWORK_TYPE = 'networkType';
export const MEDIA_CHANNEL = 'mediaChannel';
export const SINGLE_TIME = 'singleTime';
export const CONTRAST_DAY = 'contrastDay';
export const CATEGORY = 'category';
export const SOURCE = 'source';

export const PRODUCT = 'product';

// 有内置 render 且会自己处理 cascade 值格式转换的筛选器 key 列表
// 这些筛选器不需要在 NewFilter/index.tsx 和 util.ts 中提前做值格式转换
export const BUILTIN_CASCADE_RENDER_KEYS: string[] = [SYSTEM];


export const RANGE_DAILY_TYPE = ['date'];
export const RANGE_WEEKLY_TYPE = ['week'];
export const RANGE_MONTHLY_TYPE = ['month'];

export const RANTE_TYPE = ['date', 'week', 'month'];

export const RANGE_TYPE_DAY_MONTH = ['date', 'month'];

export const SHOW_NONE_PLACEHOLDER_KEYS: string[] = [];
export const HIDE_ALL_KEYS: string[] = [];
